import { IBranch } from "../../services/http/component/models/IBranch";
import { IComponent } from "../../services/http/component/models/IComponent";
import { ISearchComponentsPaginatedResult } from "../../services/http/component/models/ISearchComponentsPaginatedResult";
import { INumericalSensorConfiguration } from "../../services/http/component/models/INumericalSensorConfiguration";
import { IMeasuresResult } from "../../services/http/measurelist/models/IMeasuresResult";

export class ComponentTableViewModel
{
    rows: ComponentRowViewModel[];

    constructor()
    {
        this.rows = [];
    }

    clone(): ComponentTableViewModel
    {
        const table = new ComponentTableViewModel();
        table.rows = this.rows;
        return table;
    }

    setComponents(components: ISearchComponentsPaginatedResult): ComponentTableViewModel
    {
        const table = this.clone();

        for (const component of components.components)
        {
            if (table.containsComponent(component))
                continue;

            table.rows.push(new ComponentRowViewModel(component, table.getBranches(components.branches, component.branchId)));
        }

        return table;
    }

    setMeasures(measures: IMeasuresResult[]): ComponentTableViewModel
    {
        const table = this.clone();

        for (const measure of measures)
        {
            const component = table.getComponentByDataSourceId(measure.dataSourceId);

            if (!component)
                continue;

            component.setMeasures(measure);
        }

        return table;
    }

    getNewRows(): ComponentRowViewModel[]
    {
        return this.rows.filter(x => !x.measures);
    }

    hasNewRows(): boolean
    {
        return !!this.rows.find(x => !x.measures && x.dataSourceId);
    }

    isEmpty(): boolean
    {
        return this.rows.length === 0;
    }

    clearRows(): void
    {
        this.rows = [];
    }

    getBranches(branches: IBranch[], branchId: number): IBranch[]
    {
        return branches.filter(x => x.branchId === branchId);
    }

    private containsComponent(component: IComponent): boolean
    {
        return !!this.rows.find(x => x.component.id === component.id);
    }

    private getComponentByDataSourceId(dataSourceId: number): ComponentRowViewModel | undefined
    {
        return this.rows.find(x => x.dataSourceId === dataSourceId);
    }
}

export class ComponentRowViewModel
{
    readonly dataSourceId: number;

    measures?: IMeasuresResult;

    constructor(
        public readonly component: IComponent,
        public readonly branches: IBranch[])
    {
        // we first set the component and its branches, because that's the first data we
        // search with the pagination endpoint.
        // When we have the components, we go on a second roundtrip to retrieve the measures,
        // so measures are set at a different time.

        // we extract the data source id from the component ui configuration
        // so we can later match measures against the correct data source id.
        const configuration = JSON.parse(this.component.uiConfiguration) as INumericalSensorConfiguration;
        this.dataSourceId = configuration.dataSourceId;
    }

    setMeasures(measures: IMeasuresResult): void
    {
        this.measures = measures;
    }
}